export const SessionStatus = {
	PASSED: 'passed', // Score > 80
	LOCKED: 'locked', //
	OPEN: 'open', // Current track, not started yet
	ONGOING: 'ongoing', // Started, doing but not yet pass
};
